import {
  collection,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { toNumber } from '../utils/calc';

const USERS_COLLECTION = 'users';

/**
 * Investor / user management. Docs are keyed by lowercased email (matching
 * authService.getUserData) and gate access via the `allowed` flag.
 * Shape: { name, email, contributed_capital, allowed, is_fund_admin }
 */
export const usersService = {
  /** Subscribe to all users. */
  subscribeToUsers: (callback, errorCallback) =>
    onSnapshot(
      collection(db, USERS_COLLECTION),
      (snapshot) => callback(snapshot.docs.map((d) => ({ id: d.id, ...d.data() }))),
      errorCallback
    ),

  /** One-time read of all users. */
  getAll: async () => {
    const snapshot = await getDocs(collection(db, USERS_COLLECTION));
    return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
  },

  /**
   * Create or update an investor. The document id is the lowercased email.
   */
  saveUser: async (user) => {
    const email = (user.email || '').trim().toLowerCase();
    if (!email) throw new Error('An email address is required.');

    await setDoc(
      doc(db, USERS_COLLECTION, email),
      {
        name: user.name || '',
        email,
        contributed_capital: toNumber(user.contributed_capital) || 0,
        allowed: user.allowed !== false,
        is_fund_admin: user.is_fund_admin === true,
        updated_at: new Date().toISOString(),
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
    return email;
  },

  /** Delete an investor by document id (email). */
  deleteUser: async (id) => {
    await deleteDoc(doc(db, USERS_COLLECTION, id));
  },
};
